import React from "react";
import ReactDOM from "react-dom/client";
import { runLegacyParticipantRedirect } from "./utils/legacyParticipantPaths";
import App from "./App";
import "./index.css";
import "./admin/dashboard.css";
import "./admin/nexusSurfaces.css";
import "./mobile-responsive.css";

if (!runLegacyParticipantRedirect()) {
  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
